import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { FiUpload } from "react-icons/fi";
import { HiOutlinePlusCircle } from "react-icons/hi";
import { IoClose } from "react-icons/io5";
import { useDispatch,useSelector } from "react-redux";
import { updateDegree, fetchDegrees } from "../../redux/actions/degreeActions";
import { fetchDepartments } from "../../redux/actions/departmentActions";

export default function EditDegreePopup({ isOpen, onClose, initialData }) {
  const dispatch = useDispatch();

  const departments = useSelector((state) => state.department.department.data) || [];
  useEffect(() => {
    //dispatch(fetchDegrees());
    dispatch(fetchDepartments());
    }, [dispatch]);

  const [formData, setFormData] = useState({
    name: "",
    department: "",
    university: "",
    recognizedBy: "",
    approvedBy: "",
    type: "",
    mediumOfInstructions: "",
    exemptions: "",
    description: "",
    eligibilityCriteria: "",
    admissionCriteria: "",
    investment: "",
    file: null,
    imagePreview: null,
    files: [],
    image_url: "",
    upload_path: "",
    departmentID: "", // Track original department ID
  });

  const [uploadedDocuments, setUploadedDocuments] = useState([

  ]);

  useEffect(() => {
    if (initialData) {
      setFormData({
        name: initialData.program_name || "",
        department: initialData.department_name || "",
        departmentID: initialData.department_ID || "", // Set original department ID
        university: initialData.offering_university || "",
        recognizedBy: initialData.recognized_by || "",
        approvedBy: initialData.approved_by || "",
        type: initialData.degree_type || "",
        mediumOfInstructions: initialData.medium || "",
        exemptions: initialData.exemptions || "",
        description: initialData.description || "",
        eligibilityCriteria: initialData.eligibity_criteria || "",
        admissionCriteria: initialData.admission_criteria || "",
        investment: initialData.investment || "",
        file: null,
        imagePreview: null,
        files: [],
        image_url: initialData.image_url || "",
        upload_path: initialData.upload_path || "",
      });

      // Populate uploadedDocuments from upload_path
      const documentPaths = (initialData.upload_path || "")
        .split(",")
        .map((path) => path.trim());
      const documents = documentPaths.map((path, index) => ({
        id: Date.now() + index, // Generate a unique ID
        fileName: path,
        file: null, // No file initially, just the existing path
        existingPath: path, // Store the path from the database
      }));
      setUploadedDocuments(documents);
    }
  }, [initialData]);

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      [{ font: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["bold", "italic", "underline"],
      [{ align: [] }],
      ["clean"]
    ]
  };

  const formats = ["font", "header", "list", "bold", "italic", "underline", "align"];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleQuillChange = (field, content) => {
    setFormData((prevData) => ({ ...prevData, [field]: content }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData((prev) => ({
          ...prev,
          file,
          imagePreview: reader.result
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleAddDocumentField = () => {
    setUploadedDocuments((prev) => [...prev, { id: Date.now(), fileName: "", file: null, existingPath: null },
    ]);
  };

   // Add a new empty document upload field
  const addNewDocumentField = () => {
    setUploadedDocuments((prev) => [
      ...prev,
      { id: Date.now(), fileName: "", file: null, existingPath: null },
    ]);
  };

  const handleRemoveFile = (id) => {
    setUploadedDocuments((prev) => prev.filter((doc) => doc.id !== id));
  };

  const handleFileChange = (id, file) => {
    setUploadedDocuments((prev) =>
      prev.map((doc) =>
        doc.id === id
          ? {
              ...doc,
              file,
              fileName: file.name,
              existingPath: null, // If a new file is chosen, it's no longer an existing path
            }
          : doc
      )
    );
  };

  // Strip HTML to validate rich text fields
  const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  const handleSave = async (e) => {
    e.preventDefault();

    // Determine the department ID to send
    const departmentIDToSend =
      formData.department !== initialData.department_name
        ? formData.department
        : formData.departmentID;

    const plainDescription = stripHtml(formData.description);
    const plainEligibilityCriteria = stripHtml(formData.eligibilityCriteria);
    const plainAdmissionCriteria = stripHtml(formData.admissionCriteria);
    const plainInvestment = stripHtml(formData.investment);

    // Validate required fields
    if (!formData.name?.trim()) {
      alert("Program name is required.");
      return;
    }
    if (!formData.department?.trim()) {
      alert("Please select a department.");
      return;
    }
    if (!formData.university?.trim()) {
      alert("Offering university is required.");
      return;
    }
    if (!formData.recognizedBy?.trim()) {
      alert("Recognized by field is required.");
      return;
    }
    if (!formData.approvedBy?.trim()) {
      alert("Approved by field is required.");
      return;
    }
    if (!formData.type?.trim()) {
      alert("Degree type is required.");
      return;
    }
    if (!plainDescription.trim()) {
      alert("Description is required.");
      return;
    }
    if (!plainEligibilityCriteria.trim()) {
      alert("Eligibility criteria is required.");
      return;
    }
    // if (!plainAdmissionCriteria.trim()) {
    //   alert("Admission criteria is required.");
    //   return;
    // }
    if (!plainInvestment.trim()) {
      alert("Investment details are required.");
      return;
    }
    // if (!formData.mediumOfInstructions.trim()) {
    //   alert("Medium Of Instructions field is required.");
    //   return;
    // }
    // if (!formData.exemptions.trim()) {
    //   alert("Exemptions is required.");
    //   return;
    // }

    const formDataToSend = new FormData();
    formDataToSend.append("program_name", formData.name);
    formDataToSend.append("department_id", departmentIDToSend); // Use determined department ID
    formDataToSend.append("offering_university", formData.university);
    formDataToSend.append("recognized_by", formData.recognizedBy);
    formDataToSend.append("approved_by", formData.approvedBy);
    formDataToSend.append("degree_type", formData.type);
    formDataToSend.append("medium", formData.mediumOfInstructions);
    formDataToSend.append("exemptions", formData.exemptions);
    formDataToSend.append("description", formData.description);
    formDataToSend.append("eligibity_criteria", formData.eligibilityCriteria);
    formDataToSend.append("admission_criteria", formData.admissionCriteria);
    formDataToSend.append("investment", formData.investment);
    formDataToSend.append("file", formData.file);

    // Append new files to the FormData
    uploadedDocuments.forEach((doc) => {
      if (doc.file) {
        formDataToSend.append("files", doc.file);
      }
    });

    // Collect existing file paths that haven't been removed
    const existingFiles = uploadedDocuments
      .filter((doc) => doc.existingPath && !doc.file) // Only include files from DB, not newly chosen
      .map((doc) => doc.existingPath);

    formDataToSend.append("existing_files", JSON.stringify(existingFiles));

    try {
      console.log("Submitting form data...");
      await dispatch(
        updateDegree(formDataToSend, initialData.id)
      );

      alert("Degree updated successfully!");
      onClose();
      dispatch(fetchDegrees());
      //  window.location.reload(); // Reload the page after success
    } catch (error) {
      console.error("Error update degree:", error);
      alert("Failed to update degree. Please try again.");
    }
  };

  return (
    isOpen && (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div className="p-6 bg-white rounded-lg shadow-md w-[1169px] max-h-[90vh] overflow-y-auto">
          <div className="flex items-center justify-between mb-6">
            <h2 className="mb-4 text-xl font-semibold text-gray-700">Edit Degree Program</h2>
            <button
              type="button"
              className="text-gray-500 border rounded-md shadow-md hover:text-gray-700"
              onClick={onClose}
            >
              <IoClose className="w-6 h-6" />
            </button>
          </div>

          <form onSubmit={handleSave}>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block mb-1 text-sm font-medium text-gray-600">Department</label>
                <select
                  name="department"
                  value={formData.department}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                >
                  <option value={formData.department} disabled>
                    {formData.department || "Select department"}
                  </option>
                  {departments.map((dept) => (
                    <option key={dept.id} value={dept.id}>
                      {dept.department_name}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block mb-1 text-sm font-medium text-gray-600">Program Name</label>
                <input
                  name="name"
                  type="text"
                  value={formData.name}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                />
              </div>

              <div>
                <label className="block mb-1 text-sm font-medium text-gray-600">Offering University</label>
                <input
                  name="university"
                  type="text"
                  value={formData.university}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                />
              </div>

              <div>
                <label className="block mb-1 text-sm font-medium text-gray-600">Recognized By</label>
                <input
                  name="recognizedBy"
                  type="text"
                  value={formData.recognizedBy}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                />
              </div>

              <div>
                <label className="block mb-1 text-sm font-medium text-gray-600">Approved By</label>
                <input
                  name="approvedBy"
                  type="text"
                  value={formData.approvedBy}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                />
              </div>

              <div>
                <label className="block mb-1 text-sm font-medium text-gray-600">Type</label>
                <select
                  name="type"
                  value={formData.type} // Ensure this binds to the current formData.type value
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                >
                  <option value={formData.type} disabled>
                    {formData.type || "Select Type"}
                  </option>
                  <option value="General">General</option>
                  <option value="Honours">Honours</option>
                </select>
              </div>

            </div>

            <div className="mt-6">
              <label className="block mb-1 text-gray-700">Description</label>
              <ReactQuill
                theme="snow"
                value={formData.description}
                onChange={(content) => handleQuillChange("description", content)}
                modules={modules}
                formats={formats}
                className="h-[150px] mb-1"
              />
            </div>

            <div>
              <label className="block mt-12 mb-1 text-gray-700">Eligibility Criteria</label>
              <ReactQuill
                theme="snow"
                value={formData.eligibilityCriteria}
                onChange={(content) => handleQuillChange("eligibilityCriteria", content)}
                modules={modules}
                formats={formats}
                className="h-[150px]"
              />
            </div>

            {/* <div>
              <label className="block mt-12 mb-1 text-gray-700">Admission Criteria</label>
              <ReactQuill
                theme="snow"
                value={formData.admissionCriteria}
                onChange={(content) => handleQuillChange("admissionCriteria", content)}
                modules={modules}
                formats={formats}
                className="h-[150px]"
              />
            </div> */}
            <div>
              <label className="block mt-12 mb-1 text-sm font-medium text-gray-600">Investment</label>
              <ReactQuill
                theme="snow"
                value={formData.investment}
                onChange={(content) => handleQuillChange("investment", content)}
                modules={modules}
                formats={formats}
                className="h-[150px]"
              />
            </div>
            {/* <div className="grid grid-cols-2 gap-4 mt-12">


              <div>
                <label className="block mb-1 text-sm font-medium text-gray-600">Medium of Instructions</label>
                <input
                  name="mediumOfInstructions"
                  type="text"
                  value={formData.mediumOfInstructions}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                />
              </div>

              <div>
                <label className="block mb-1 text-sm font-medium text-gray-600">Exemptions</label>
                <input
                  name="exemptions"
                  type="text"
                  value={formData.exemptions}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                />
              </div>


            </div> */}
            <div className="grid grid-cols-3 gap-4 mt-6 mb-4">
           

              {/* Image Upload Section */}
              {/* <div className="flex flex-col items-center justify-center w-full h-[225px] p-5 border border-gray-300 border-dashed rounded-md">
                <label className="relative flex flex-col items-center justify-center w-full h-full cursor-pointer">
                  <input
                    id="fileInput"
                    type="file"
                    name="file"
                    accept="image/*"
                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                    onChange={handleImageChange}
                  />
                  {formData.imagePreview || formData.image_url ? (
                    <div className="w-full h-full">
                      <img
                        src={formData.image_url || formData.imagePreview  }
                        alt="Uploaded Preview"
                        className="object-contain w-full h-full rounded-md opacity-60"
                      />
                      <div className="absolute top-0 left-0 flex items-center justify-center w-full h-full gap-2 bg-opacity-50">
                        <button
                          type="button"
                          className="px-4 py-2 bg-white border rounded-md text-primary-color border-primary-color"
                          onClick={() => document.getElementById('fileInput').click()} // Trigger input click
                        >
                          Browse Image
                        </button>
                      </div>
                    </div>
                  ) : (
                    <>
                      <FiUpload className="w-10 h-10 p-2 mb-3 text-gray-400 bg-gray-100 border-none rounded-md" />
                      <p className="text-black">Drag and drop image here</p>
                      <p className="text-gray-400">or</p>
                      <button
                        type="button"
                        className="px-4 py-2 mt-2 text-[#92288C] font-semibold bg-[#92288C] bg-opacity-10 rounded-md"
                        onClick={() => document.getElementById('fileInput').click()}
                      >
                        Browse Image
                      </button>
                    </>
                  )}
                </label>
              </div> */}

              {/* Document Upload Section */}
              <div className="col-span-2">
              <div>
                <label className="block mt-6 mb-1 text-sm font-medium text-gray-600">Medium of Instructions</label>
                <input
                  name="mediumOfInstructions"
                  type="text"
                  value={formData.mediumOfInstructions}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                />
              </div>
                <label className="block mb-1 text-sm font-medium text-gray-600">
                  Upload Documents
                </label>
                {uploadedDocuments.map((doc, index) => (
                  <div className="flex items-center gap-4 mb-4" key={doc.id}>
                    <input
                      type="text"
                      value={doc.fileName}
                      readOnly
                      className="flex-grow px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                      placeholder="Document Name"
                    />

                    {/* Render REMOVE button for all */}
                    <button
                      type="button"
                      className="flex items-center px-4 py-2 text-red-500 border border-red-500 rounded-md"
                      onClick={() => handleRemoveFile(doc.id)}
                    >
                      Remove
                    </button>

                    {/* Show browse ONLY if it's a new document or has no existing path */}
                    {(!doc.existingPath || doc.existingPath === "") && (
                      <label className="flex items-center px-4 py-2 text-[#92288C] font-semibold bg-[#92288C] bg-opacity-10 rounded-md cursor-pointer">
                        Browse File
                        <input
                          type="file"
                          className="hidden"
                          onChange={(e) =>
                            handleFileChange(doc.id, e.target.files[0])
                          }
                        />
                      </label>
                    )}

                    {/* Show "Add More" only for the last one */}
                    {index === uploadedDocuments.length - 1 && (
                      <button
                        type="button"
                        className="flex items-center px-4 py-2 text-primary-color"
                        onClick={addNewDocumentField}
                      >
                        <HiOutlinePlusCircle className="mr-2" /> Add More
                      </button>
                    )}
                  </div>
                ))}

              </div>

            </div>

            {/* Buttons Section */}
            <div className="flex justify-end mt-6 space-x-4">
              <button
                type="button"
                className="px-4 py-2 text-gray-600 bg-gray-200 rounded-md hover:bg-gray-300"
                onClick={onClose}
              >
                Back
              </button>
              <button
                type="submit"
                className="px-4 py-2 text-white rounded-md bg-primary-color"
              >
                Update
              </button>
            </div>



          </form>
        </div>
      </div>
    )
  );
}
